<template>
  <div>
    <div ref="instance" class="modal fade show" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div :class="{'p-0':fullHeader}" class="modal-header">
            <slot name="header" />
          </div>
          <div class="modal-body">
            <slot name="body" />
          </div>
          <div class="modal-footer flex-wrap justify-content-center position-relative">
            <slot name="footer" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { $$ } from "../../helpers/ui/OR_jquery";
export default {
  props: {
    fullHeader: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.$nextTick(() => {
      let that = this;
      $$(this.$refs.instance).modal("show");
      $$(this.$refs.instance).on("hidden.bs.modal", function() {
        that.$emit("close");
      });
    });
  },
  methods: {
    hideModal() {
      $$(this.$refs.instance).modal("hide");
    }
  }
};
</script>
